/* eslint-disable react/jsx-indent-props */
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "../use.store";
import { informationID, s3Url } from "../utils/constants";

const LobbyEscalatorsOperatingGuideComponent = observer(() => {
  const { generalStore } = useStores();
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const filter = generalStore.information.filter(
      (item) => item.categoryId === informationID.escalatorLiftGuide
    );
    // filter.map((data) => {
    //   const items = data.description
    //     .match(/\(([^)]+)\)/g)
    //     .map((item) => item.slice(1, -1));

    //   const parsedItems = items.map((item) => {
    //     const [title, value] = item.split(":");
    //     return { title: title.trim(), value: value.trim() };
    //   });
    //   data.description = parsedItems;
    // });
    setFilteredData(filter);
  }, []);

  return (
    <div className="flex flex-col items-center w-full">
      {filteredData &&
      filteredData[0] &&
      filteredData[0].files &&
      filteredData[0].files.length > 0 ? (
        filteredData[0].files.map((data, index) => {
          return (
            <img
              src={`${s3Url}/information/${data.logo}`}
              alt="operating-hours"
              className="w-[70%]"
            />
          );
        })
      ) : (
        <div>No data available</div>
      )}
    </div>
    //   <div className="flex flex-col gap-2 bg-white p-4 md:p-6 md:gap-6 rounded-tl-md rounded-tr-md items-center w-full">
    //    {filteredData &&
    //     filteredData.length > 0 &&
    //     filteredData[0] &&
    //     filteredData[0].description ? (
    //       filteredData[0].description.map((data, index) => {
    //         return (
    //           <div className="flex flex-row justify-between w-full" key={index}>
    //             <span className="text-sm md:text-2xl text-black font-bold ">
    //               {data.title}:
    //             </span>
    //             <span className="text-sm md:text-2xl text-black">
    //               {data.value}
    //             </span>
    //           </div>
    //         );
    //       })
    //     ) : (
    //       <div>No schedule available</div>
    //     )}
    //     <div className="flex flex-row justify-between w-full">
    //       <span className="text-sm md:text-2xl text-black font-bold ">
    //         B2 – L4:
    //       </span>
    //       <span className="text-sm md:text-2xl text-black">
    //         {" "}
    //         Use the escalators
    //       </span>
    //     </div>
    //     <div className="flex flex-row justify-between w-full">
    //       <span className="text-sm md:text-2xl text-black font-bold ">
    //         L5 – L18:
    //       </span>
    //       <span className="text-sm md:text-2xl text-black"> Use Lift B</span>
    //     </div>
    //     <div className="flex flex-row justify-between w-full">
    //       <span className="text-sm md:text-2xl text-black font-bold ">
    //         L18 and above:
    //       </span>
    //       <span className="text-sm md:text-2xl text-black">Use Lift A</span>
    //     </div>
    //  </div>
  );
});

export default LobbyEscalatorsOperatingGuideComponent;
